<template>
  <div>
    <b-row class="mb-2">
      <b-col
        cols="12"
        md="6"
        class=""
      >
        <div class="d-flex align-items-center date-interval-picker">
          <b-button
            v-show="false"
            variant="outline-primary"
            class="action d-none d-md-inline-block mt-2 mr-1"
            :disabled="disabledPrevious || loading"
            title="Voltar 1 ano"
            @click="previous"
          >
            <feather-icon
              size="18"
              icon="ChevronLeftIcon"
            />
          </b-button>
          <div>
            <label
              v-show="false"
              for="workplace-id"
            >De</label>
            <v-select
              v-show="false"
              v-model="lastYearDate"
              :options="yearOptions"
              :clearable="false"
              class="year-picker"
              :disabled="loading"
            />
          </div>
          <div class="ml-1">
            <label for="workplace-id">Ano</label>
            <v-select
              v-model="baseYearDate"
              :options="yearOptions"
              :clearable="false"
              class="year-picker"
              :disabled="loading"
            />
          </div>
          <b-button
            v-show="false"
            variant="outline-primary"
            class="action d-none d-md-inline-block mt-2 ml-1"
            title="Avançar 1 ano"
            :disabled="loading"
            @click="next"
          >
            <feather-icon
              size="18"
              icon="ChevronRightIcon"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col
        cols="12"
        md="12"
        xl="10"
        :style="mobile.mobile ? 'min-height: 900px' : 'min-height: 500px'"
      >
        <div
          class="h-100 d-flex flex-column flex-xl-row align-items-center text-left"
        >
          <duty-type-pie
            :year="baseYearDate"
            :mobile="mobile"
            :chart-data="chartDataWorkplace"
          />
        </div>
      </b-col>
      <b-col
        cols="12"
        md="12"
        xl="10"
        style="min-height: 550px"
      >
        <div
          class="h-100 d-flex flex-column flex-xl-row align-items-center text-left"
        >
          <duty-type-bar
            :mobile="mobile"
            :chart-data="chartDataWorkplace"
          />
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col
        cols="12"
        md="12"
        xl="6"
        style="min-height: 500px"
      >
        <div
          class="h-100 d-flex flex-column flex-xl-row align-items-center text-left"
        >
          <age-range-pie
            :year="baseYearDate"
            :mobile="mobile"
            :chart-data="chartDataWorkplace2"
          />
        </div>
      </b-col>
      <b-col
        cols="12"
        md="12"
        xl="6"
        style="min-height: 500px"
      >
        <div
          class="h-100 d-flex flex-column flex-xl-row align-items-center text-left"
        >
          <age-range-bar
            :mobile="mobile"
            :chart-data="chartDataWorkplace2"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCol, BRow, BButton,
} from 'bootstrap-vue'
import store from '@/store'
import { onUnmounted, ref, watch } from '@vue/composition-api'
import { addYears } from 'date-fns'
import vSelect from 'vue-select'
import chartStoreModule from '@/views/charts/chartStoreModule'
import DutyTypeBar from './DutyTypeBar.vue'
import DutyTypePie from './DutyTypePie.vue'
import AgeRangeBar from './AgeRangeBar.vue'
import AgeRangePie from './AgeRangePie.vue'

export default {
  components: {
    DutyTypeBar,
    DutyTypePie,
    AgeRangeBar,
    AgeRangePie,
    vSelect,
    BRow,
    BCol,
    BButton,
  },
  props: {
    mobile: {
      type: Object,
      default: () => ({ mobile: false }),
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-chart'
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, chartStoreModule)

    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    const currentYear = new Date().getFullYear()
    const getYear = (sub = 0) => addYears(new Date(), sub).getFullYear()

    const yearOptions = []
    const lastYearDate = ref(getYear(-1))
    const baseYearDate = ref(getYear())
    const loading = ref(true)
    const disabledNext = ref(true)
    const disabledPrevious = ref(false)
    const currentDateFormatted = ref('')
    const chartDataWorkplace = ref(null)
    const chartDataWorkplace2 = ref(null)

    const countYears = currentYear - 2022
    new Array(countYears + 1).fill(0).forEach((_, i) => {
      yearOptions.push(2022 + i)
    })

    const refresh = () => {
      loading.value = true
      const baseYear = baseYearDate.value

      store.dispatch('app-chart/fetchDutyTypePerYear', {
        base_year: baseYear,
      })
        .then(response => {
          chartDataWorkplace.value = response.data.data || {}
        })
        .finally(() => {
          loading.value = false
        })
      store.dispatch('app-chart/fetchAgeRangePhysician', {
        base_year: baseYear,
      })
        .then(response => {
          chartDataWorkplace2.value = response.data.data || {}
        })
        .finally(() => {
          loading.value = false
        })
    }
    refresh()

    watch([baseYearDate, lastYearDate], () => {
      refresh()
    })

    const previous = () => {
      const year = lastYearDate.value - 1
      if (year <= 2022) {
        disabledPrevious.value = true
      } else {
        disabledPrevious.value = false
      }
      if (year < 2022) {
        return
      }

      lastYearDate.value = year
      baseYearDate.value -= 1
      refresh()
    }
    const next = () => {
      const year = baseYearDate.value + 1
      if (year <= currentYear) {
        lastYearDate.value += 1
        baseYearDate.value += 1
        disabledPrevious.value = false
        refresh()
      }
    }

    return {
      loading,
      yearOptions,
      baseYearDate,
      lastYearDate,
      previous,
      next,
      disabledNext,
      disabledPrevious,
      currentDateFormatted,
      chartDataWorkplace,
      chartDataWorkplace2,
    }
  },
}
</script>

<style lang="scss" scoped>
.v-text-field--box .v-input__slot, .v-text-field--outline .v-input__slot{
  max-height: 56px!important;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select";
.select-subtitle {
  font-size: 12px;
}

.card-body{
  position: relative;
  .pie-text{
    width: 105px;
    position:absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 44%;
    bottom: 0;
  }
  }

.card-header .title {
  min-width: 45px;
  text-align: center;
}
.action {
  padding: 2px 3px;
  margin-right: 5px;
  & ~ .action {
    margin-left: 5px;
  }
}
.year-picker {
  min-width: 100px;
}
</style>
